import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color } from "@stoneage/XDL/Utilities";
import React, { FC } from "react";

import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

// XNG changes
type Props = OwnProps;

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    topConent?: GridItemProps;
    linkListGridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    subscribeContainer?: InjectableCss;
    podcastContainer?: InjectableCss;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    footerBanner?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    // <XNG changes>
    topConent: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
        `,
    },
    linkListGridItem: {
        width: [6, 6, 3, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    subscribeContainer: {
        css: css`
            padding: 20px;
            padding-bottom: 23px;
            border: 1px solid ${color("common.ui9")};
            border-bottom-width: 0;
            width: 100%;
        `,
    },
    podcastContainer: {
        css: css`
            width: 100%;
            border: 1px solid ${color("common.ui9")};
        `,
    },
    // </ XNG changes>

    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },

    // <XNG changes>
    footerBanner: {
        css: css`
            display: flex;
            gap: 40px;
            margin-top: 29px;
            padding-bottom: 16px;
            @media (max-width: 576px) {
                flex-direction: column;
                gap: 16px;
            }

            a {
                span {
                    color: ${color("common.ui5")} !important;
                    font-size: 12px;
                    font-weight: 400;
                    &:hover,
                    &:focus {
                        color: ${color("primary.main")} !important;
                    }
                }
            }

            .copyright {
                color: ${color("common.ui5")};
                font-size: 12px;
                font-weight: 400;
            }
        `,
    },
    // </ XNG changes>
};

export const siteMessages = {
    siteName: "StoneAge, Inc",
};

const FooterContainer: FC<Props> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    return (
        <StyledWrapper>
            <GridContainer>
                <GridItem {...styles.linkListGridItem}>
                    <Zone zoneName="LinkList1" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkListGridItem}>
                    <Zone zoneName="LinkList2" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkListGridItem}>
                    <Zone zoneName="LinkList3" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkListGridItem}>
                    <Zone zoneName="LinkList4" contentId={id} />
                </GridItem>
                <GridItem {...styles.subscribeGridItem}>
                    <StyledWrapper {...styles.subscribeContainer}>
                        <Zone zoneName="subscribe" contentId={id} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.podcastContainer}>
                        <Zone zoneName="podcast" contentId={id} />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
            <StyledWrapper>
                <Zone zoneName="SocialLinks" contentId={id} />
            </StyledWrapper>
            <StyledWrapper {...styles.footerBanner}>
                <Zone zoneName="BottomFooterLink" contentId={id} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
